import { call, put, select } from 'redux-saga/effects';
import { FeedMediaStates, RTCClient } from 'utils/webrtc';
import { interactionTriggered } from 'features/application/actions';
import { hasPermissionsSaga } from 'features/permissions/sagas/hasPermissionsSaga';
import { PermissionTypes } from 'features/permissions/types';
import { logger } from 'utils/logger';
import { selectMediaDevicePermissions } from 'features/user-media/userMediaSlice';
import { type PermissionStatus } from 'features/user-media/types';

export function* toggleLocalVideoSaga() {
  const canBroadcastVideo: boolean = yield call(hasPermissionsSaga, PermissionTypes.broadcastVideo);

  if (!canBroadcastVideo) {
    logger.remote().warn('Tried to toggle video without broadcast permission');
    return;
  }

  const camPermissions: PermissionStatus = yield select(selectMediaDevicePermissions, 'videoinput');
  if (camPermissions !== 'granted') {
    logger.remote().warn('Tried to toggle video without media device permission');
    return;
  }

  const mediaStates: FeedMediaStates = yield call(RTCClient.publishingFeed.getMediaStates);

  if (mediaStates.video.broadcasting) {
    yield put(interactionTriggered('muteVideo'));
  } else {
    yield put(interactionTriggered('unmuteVideo'));
  }

  yield call(RTCClient.publishingFeed.toggleVideoBroadcasting);
}
